import React from 'react';
import './Loader.css';

const loader = () => (
    <div className="loader">Loading...</div>
)

export default loader;
